export default __webpack_public_path__ + "static/N0124-311201ba4297d5da3d4ada5880deb861.png";